import { Injectable, NgZone } from '@angular/core';
import { WindowRefService } from 'app/shivam/added-pooja-list/WindowRef.service';
import { AuthenticationService } from 'app/shivam/shared/auth/authentication.service';
import { UntypedFormGroup } from '@angular/forms';
import { initializeApp, getApps, getApp } from '@angular/fire/app';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from '@angular/fire/auth';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginFormService {
  mobileNumber: any;
  windowRef: any;
  verificationCode: string;
  loading: boolean;
  constructor(private win: WindowRefService,
    private ngZone: NgZone, private authenticationService: AuthenticationService) {
    this.windowRef = this.win.nativeWindow;
  }

  private getPhoneAuth() {
    const appName = 'phoneVerificationApp';
    const app = getApps().find(a => a.name === appName)
      || initializeApp(environment.phoneVerificationFirebase, appName);
    return getAuth(app);
  }

  async loadCapthaVerifier() {
    this.loading = true;
    const auth = this.getPhoneAuth();

    try {
      if (!this.windowRef.recaptchaVerifier) {
        this.windowRef.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
          size: 'invisible'
        });
      }

      // Ensure the verifier is rendered before attempting to send the phone code
      this.windowRef.recaptchaWidgetId = await this.windowRef.recaptchaVerifier.render();

      // Only call sendLoginCode after successful rendering
      await this.sendLoginCode();

      this.loading = false;
      this.authenticationService.loading = false;
    } catch (error) {
      console.error('reCAPTCHA/OTP initialization error:', error);
      this.loading = false;
      this.authenticationService.loading = false;
      // You could also notify the authentication service of this error if needed
    }
  }

  async sendLoginCode() {
    const num = this.mobileNumber;
    const appVerifier = this.windowRef.recaptchaVerifier;
    await signInWithPhoneNumber(this.getPhoneAuth(), num, appVerifier)
      .then(result => {
        console.log('otp verify result', result);
        this.windowRef.confirmationResult = result;
        this.ngZone.run(() => {
          this.loading = false
          this.authenticationService.loading = false;
        });
      })
      .catch(error => {
        console.log('otp verify error', error);
        this.ngZone.run(() => {
          this.loading = false
          this.authenticationService.loading = false;
        });
      });
  }

  verifyLoginCode(form: UntypedFormGroup) {
    if (form.invalid) {
      return;
    }
    this.authenticationService.verifyOTPLogin(form.value);
  }

}
